<mat-form-field appearance="outline" class="w-100 m-t-5" (click)="popUpShow()" style="cursor: pointer;" [ngClass]="{
  'mat-form-field-compact': size === 'compact',
  'mat-form-field-xs': size === 'xs'}">
    <div class="flex align-items-center">
        <input matInput type="text"   [value]="displayValue || control.value" [placeholder]="placeholder" >
        <svg class="pc-icon">
            <use xlink:href="assets/fonts/custom-icon.svg#custom-search-normal"></use>
        </svg>
    </div>
</mat-form-field>
<div class="error">
    <app-error [control]="control" [type]="type"></app-error>
</div>